<script lang="ts">
	import type { addToCartSchema } from '$lib/validations/cart/add-to-cart-schema';
	import AddToCartForm from '$lib/components/app/cart/add-to-cart-form.svelte';
	import type { SelectCart, SelectCartItem } from '$db/tables';
	import type { SuperValidated } from 'sveltekit-superforms';
	import { Button } from '$lib/components/ui/button';
	import type { Infer } from 'sveltekit-superforms';
	import RemoveFromCartForm from '$lib/components/app/cart/remove-from-cart-form.svelte';
	import type { removeFromCartSchema } from '$lib/validations/cart/remove-from-cart-schema';

	interface Props {
		cart: {
			cart: SelectCart;
			cartItems: SelectCartItem[];
		};
		courseOfferingId: number;
		addToCartForm: SuperValidated<Infer<typeof addToCartSchema>>;
		removeFromCartForm: SuperValidated<Infer<typeof removeFromCartSchema>>;
		currentCount: number;
		maxParticipants: number;
		sportspass: boolean;
	}

	let {
		cart,
		courseOfferingId,
		addToCartForm,
		currentCount,
		maxParticipants,
		sportspass,
		removeFromCartForm
	}: Props = $props();
</script>

<div class="flex justify-end">
	{#key cart}
		<div class="md:w-64">
			{#if !cart?.cartItems.some((cartItem) => cartItem && cartItem.courseOfferingId === courseOfferingId)}
				<AddToCartForm
					{addToCartForm}
					{courseOfferingId}
					warning={maxParticipants - currentCount < 5 ? true : false}
					{sportspass}
				/>
			{:else}
				<RemoveFromCartForm
					variant="outline"
					{removeFromCartForm}
					cartItemId={cart.cartItems.filter((v) => v.courseOfferingId === courseOfferingId)[0].id}
				/>
			{/if}
		</div>
	{/key}
</div>
